import {createAction} from 'redux-actions'

//Actions para guardar reducer de los catálogos de cotizacion

//CATALOGOS TRAVEL BTA EMPRESSA -----------------------
export const setCatalogoBtaEmpresas = createAction("SET_CATALOGO_BTA_EMPRESAS");

export const FetchCatalogoBtaEmpresas = (param) => async dispatch => {
  dispatch(setCatalogoBtaEmpresas(param));
};

// FIN CATALOGOS TRAVEL BTA EMPRESSA -----------------------


//CATALOGOS ACCIDENTES PERSONALES -------------------------------------

export const setCatalogosAPIndividual = createAction("SET_CATALOGO_AP_INDIVIDUAL")


//FIN CATALOGOS ACCIDENTES PERSONALES -------------------------------------
